import { AnalyticsContext } from '@carvana/eventable-clickstream';
import { useContext, useEffect } from 'react';
import UserVehicleContext from '~/context/vdp/UserVehicleContext';
import { usePriceDrop } from '~/hooks/vdp';

export default function useSendPriceDropEvent() {
  const { trackEvent } = useContext(AnalyticsContext);
  const { vehiclePricingInfo } = useContext(UserVehicleContext);
  const { previousPrice, price, showPriceDrop, totalDiscount } = usePriceDrop();

  useEffect(() => {
    if (!showPriceDrop || !vehiclePricingInfo.isLoaded) return;

    trackEvent('Price Drop Data', {
      price,
      previousPrice,
      totalDiscount
    });
  }, [
    previousPrice,
    price,
    showPriceDrop,
    totalDiscount,
    trackEvent,
    vehiclePricingInfo.isLoaded
  ]);

  return null;
}
